import React from 'react';
import Button from '../../../Button';
import HiddenIcon from './Icons/Hidden';
import BlockedIcon from './Icons/Blocked';
import { scaleToSize } from '../../_helpers';
import BackgroundImage from '../../../DeviationBackground/BackgroundImage';
import MediaService from '../../../utils/DeviationMediaService';
import s from './Hidden.scss';
export var HiddenLayout = function (_a) {
    var iconType = _a.iconType, title = _a.title, text = _a.text, buttons = _a.buttons, secondaryButton = _a.secondaryButton, deviation = _a.deviation, width = _a.width, height = _a.height;
    var background = MediaService.getSmallestThumb(deviation);
    var fullImage = MediaService.getFullviewForSize(deviation, width, height);
    var childBoxSize = fullImage
        ? scaleToSize(fullImage, { width: width, height: height })
        : { width: width, height: height };
    return (React.createElement("div", { style: {
            width: width,
            height: height,
        }, className: s['root'] },
        React.createElement("div", { style: childBoxSize, className: s['blocked-placeholder'] },
            background && React.createElement(BackgroundImage, { src: background.src, blur: true }),
            React.createElement("div", { className: s['blocked-wrap'] },
                React.createElement("div", { className: s['blocked-icon'] }, iconType === 'hidden' ? React.createElement(HiddenIcon, null) : React.createElement(BlockedIcon, null)),
                title && React.createElement("div", { className: s['blocked-title'] }, title),
                Array.isArray(text)
                    ? text.map(function (node, idx) {
                        return node && (React.createElement("div", { key: idx, className: title ? s['blocked-text'] : s['blocked-text-large'] }, node));
                    })
                    : text && (React.createElement("div", { className: title ? s['blocked-text'] : s['blocked-text-large'] }, text)),
                buttons &&
                    buttons.map(function (button) {
                        return button && (React.createElement(Button, { key: button.label, view: "b14", height: "medium", onClick: button.onClick, href: button.href, biData: button.biData }, button.label));
                    }),
                secondaryButton && (React.createElement("button", { className: s['secondary-button'], onClick: secondaryButton.onClick }, secondaryButton.label))))));
};
HiddenLayout.displayName = 'HiddenLayout';
export default HiddenLayout;
//# sourceMappingURL=HiddenLayout.js.map